import { configureStore } from "@reduxjs/toolkit"
import authReducer from "../features/auth/authSlice"
import { apiSlice } from "./api/apiSlice"
import chapelReducer from "../features/chapel/chapelSlice";
import userReducer from "../features/user/userSlice";
import modalReducer from "../features/modal/modalSlice";
import productReducer from "../features/product/productSlice";
import clientReducer from "../features/client/clientSlice";
import packageReducer from "../features/package/packageSlice";
import categoryReducer from "../features/category/categorySlice";
import reportsReducer from "../features/reports/reportsSlice";
import orderReducer from "../features/order/orderSlice";
import guestReducer from "../features/guest/guestSlice";
import systemReducer from "../features/system/systemSlice";
import setupReducer from "../features/setup/setupSlice";

const isProd = process.env.REACT_APP_NODE_ENV === "production";

export const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        auth: authReducer,
        chapel: chapelReducer,
        user: userReducer,
        modal: modalReducer,
        product: productReducer,
        client: clientReducer,
        package: packageReducer,
        addPackageToChapel: packageReducer,
        category: categoryReducer,
        reports: reportsReducer,
        order: orderReducer,
        guest: guestReducer,
        system: systemReducer,
        setup: setupReducer,
    },
    middleware: getDefaultMiddleware => 
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore RTK Query mutations that return Blobs
                ignoredActions: [
                'api/executeMutation/fulfilled',
                'api/executeMutation/rejected',
                ],
                ignoredPaths: ['api.mutations'], // optional: also ignore mutations state
            },
        }).concat(apiSlice.middleware),
    devTools: !isProd
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch